import { Box, LinearProgress, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ProgressProps } from "./Progress.types";
import { CustomRegex } from "../../utils/regex";

export function Progress({ percentageOfCompletion } : ProgressProps) {
  const { t } = useTranslation();

  const theme = useTheme();
  const progressAmount = CustomRegex.matchNumber(percentageOfCompletion) ?? "1";
  const handleValueZero =()=> Number(progressAmount) > 0 ? Number(progressAmount) : 0.5;
  return (
    <>
      <LinearProgress
        aria-label={ t("completion_percentage") }
        variant="determinate"
        value={ handleValueZero() }
        sx={ {
          height: "0.25rem",
          width: "100%",
          borderRadius: "0.25rem",
          mt: 1,
          backgroundColor: theme.customColors.border,
          "& .MuiLinearProgress-bar": {
            backgroundColor: theme.customColors.systemPrimary01Alternative02
          }
        } }
      />
      <Box
        sx={ {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap:"0.25rem",
          mt: "0.5rem"
        } }
      >
        <Typography
          sx={ {
            color: theme.customColors.exploreCardText,
            fontSize: "0.75rem",
            fontWeight: 400
          } }
          variant="body2"
        >
          { t("completion") }{ " " }{ progressAmount }%
        </Typography>
      </Box>
    </>
  );
}
